<div class="table-row" #rowItem>
    <ng-container *ngTemplateOutlet="columnsRenderer; context:{ record: record }"></ng-container>
</div>
